"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.switchClasses = exports.Switch = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@mui/material/styles");
const Switch_1 = __importStar(require("@mui/material/Switch"));
Object.defineProperty(exports, "switchClasses", { enumerable: true, get: function () { return Switch_1.switchClasses; } });
const Typography_1 = require("../typography/Typography");
const Stack_1 = require("../stack/Stack");
const Box_1 = require("../box/Box");
const DriftSwitchRoot = (0, styles_1.styled)(Box_1.Box, {
    name: 'DriftSwitch',
    slot: 'root',
})(() => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
}));
const LabelText = (0, styles_1.styled)(Typography_1.Typography, {
    name: 'DriftSwitch',
    slot: 'labelText',
})(() => ({}));
const ErrorText = (0, styles_1.styled)(Typography_1.Typography, {
    name: 'DriftSwitch',
    slot: 'errorText',
})(() => ({}));
const Switch = (inProps) => {
    const props = (0, styles_1.useThemeProps)({ props: inProps, name: 'DriftSwitch' });
    const { textLeft, textRight, error, labelProps, errorProps } = props, rest = __rest(props, ["textLeft", "textRight", "error", "labelProps", "errorProps"]);
    return (react_1.default.createElement(DriftSwitchRoot, { ownerState: props },
        react_1.default.createElement(Stack_1.Stack, { direction: "row", sx: { alignItems: 'center' } },
            textLeft && (react_1.default.createElement(LabelText, Object.assign({}, labelProps, { ownerState: props }), textLeft)),
            react_1.default.createElement(Switch_1.default, Object.assign({}, rest)),
            textRight && (react_1.default.createElement(LabelText, Object.assign({}, labelProps, { ownerState: props }), textRight))),
        error && (react_1.default.createElement(ErrorText, Object.assign({}, errorProps, { ownerState: props }), error))));
};
exports.Switch = Switch;
//# sourceMappingURL=Switch.js.map